import scoring from '../data/scoring';
import { getPicks } from './picksApi';
import { getResults } from './resultsApi';
import API_BASE from './config';

function scoreForPicks(results, picks, dnf) {
    let score = 0;
    const exact = scoring.correctPosition || 2;
    const top10 = scoring.correctTop10 || 1;
    const dnfDriver = scoring.correctDnfDriver || 2;
    const noDnf = scoring.correctNoDnf || 1;

    // results and picks are arrays of driver IDs. Compare by ID.
    const pickIds = (picks || []).map((x) => {
        if (x == null) return null;
        if (typeof x === 'object' && x.id) return x.id;
        return Number(x);
    });
    pickIds.forEach((driverId, i) => {
        if (!driverId) return;
        const pos = results.findIndex((r) => Number(r) === Number(driverId));
        if (pos === -1) return;
        if (pos === i) score += exact; else if (pos < 10) score += top10;
    });

    if (dnf && dnf !== null) {
        const pos = results.findIndex((r) => Number(r) === Number(dnf));
        if (pos === -1) score += dnfDriver;
    } else if (dnf === null) {
        if (results && results.length === 10) score += noDnf;
    }

    return score;
}

export async function getLeaderboard(raceId) {
    const results = await getResults(raceId);
    // fetch users and then fetch each user's picks from the user-scoped endpoint
    try {
        const usersRes = await fetch(`${API_BASE}/users`, { headers: { 'Accept': 'application/json' } });
        let users = [];
        if (usersRes.ok) users = await usersRes.json();
        const picksArrays = await Promise.all(users.map(async (u) => {
            try {
                const p = await getPicks(raceId, u.id);
                return p;
            } catch (e) {
                return [];
            }
        }));
        const flat = picksArrays.flat();
        const board = flat.map((p) => ({ username: p.username, score: scoreForPicks(results, p.picks, p.dnf) }));
        board.sort((a, b) => b.score - a.score);
        return board;
    } catch (err) {
        console.error('leaderboardApi.getLeaderboard error', err);
        return [];
    }
}

export async function getLeaderboardAll() {
    try {
        const res = await fetch(`${API_BASE}/leaderboard/all`, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) {
            throw new Error('Failed to fetch leaderboard');
        }
        const payload = await res.json();
        return payload;
    } catch (err) {
        console.error('leaderboardApi.getLeaderboardAll error', err);
        return { races: [], perRace: {}, totals: [] };
    }
}
